module.exports = __webpack_public_path__ + "img/batteryCar.c627a768.png";